import type { RowData } from "@tanstack/react-table";
import type { ViewTableHeader, ViewTableInstance } from "./table";

export function getLeafColumnHeaders<TData extends RowData>(
    table: Pick<ViewTableInstance<TData>, "getLeafHeaders">,
): Array<ViewTableHeader<TData, unknown>> {
    return table.getLeafHeaders().filter((h) => !h.subHeaders.length);
}
